module.exports = __webpack_public_path__ + "img/album17_17.85227467.jpg";